import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CircularProgressWithLabel } from '../shared/MuiSharedElements';
// function getInfoScoreMatching(evt){
//     return (
//         'competences fonctionnelles: ' + evt?.funcSkillsScore +
//         '<br/> Tech Skills: ' + evt?.techSkillsScore+
//         '<br/> Exp Score: '+ evt?.experienceScore+
//         '<br/> langue Score : ' + evt?.langueScore+
//         '<br/> certif Score : ' + evt?.certifScore);
// }
export default function DialogMatchingScore(props) {
    const { setOpenDialogMatchingScore, openDialogMatchingScore , rowData} = props;
    const { i18n } = useTranslation();
    const handleClose = () => {
        setOpenDialogMatchingScore(false);
    };

    return (
        <Dialog
            onClose={handleClose}
            open={openDialogMatchingScore}
        >
            <DialogTitle>{i18n.t('les scores de matching')}</DialogTitle>
            <List sx={{ pt: 0 }}>
                { rowData?.funcSkillsScore>0 &&
                <ListItem>
                    {i18n.t('Compétences fonctionnelles')} : <CircularProgressWithLabel value={(rowData?.funcSkillsScore) * 100} />
                </ListItem>}
                {rowData?.techSkillsScore>0 &&
                <ListItem>
                    {i18n.t('Compétences techniques')} : <CircularProgressWithLabel value={(rowData?.techSkillsScore) * 100} />
                </ListItem>}
                {rowData?.experienceScore>0 &&
                <ListItem>
                    {i18n.t('Experiences')} : <CircularProgressWithLabel value={(rowData?.experienceScore) * 100} />
                </ListItem>}
                {rowData?.langueScore>0 &&
                <ListItem>
                    {i18n.t('Langues')} : <CircularProgressWithLabel value={(rowData?.langueScore) * 100} />
                </ListItem>}
                {rowData?.certifScore>0 &&
                <ListItem>
                    {i18n.t('Certifications')} : <CircularProgressWithLabel value={(rowData?.certifScore) * 100} />
                </ListItem>}
            </List>
        </Dialog>
    );
}

DialogMatchingScore.propTypes = {
    setOpenDialogMatchingScore: PropTypes.func.isRequired,
    openDialogMatchingScore: PropTypes.bool.isRequired,
    rowData: PropTypes.any.isRequired,
};